import React, { memo } from 'react';
import { motion } from 'framer-motion';
import SimpleMarkerPopup from './SimpleMarkerPopup';

const simpleMarker = (props) => (
  <motion.div
    transition={{
 type: 'spring', stiffness: 100, damping: 7, precision: 0.001,
}}
    whileHover={{ scale: 1.08, zIndex: 99999 }}
    style={{ zIndex: 999, position: 'relative' }}
  >
    <SimpleMarkerPopup {...props}>
      <div className="simple-marker-container">
        <div className={`simple-marker ${props.markerClassName || ''}`} />
      </div>
    </SimpleMarkerPopup>
  </motion.div>
);

export default memo(simpleMarker);
